import { css } from 'lit';
export const styles = css`:host(.inactive){display:none}:host{width:100%}`;
